<template>
    <div class="report-audio">
        <!-- 背景音乐部分 -->
        <audio id="audio" v-bind:src="audioUrl" preload="auto" autoplay loop></audio>
    </div>
</template>

<script>
import * as config from '../../modules/data/config'
export default {
    name: 'ReportAudio',
    data() {
        return {
            audioObj: undefined, audioUrl: '',
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
        this.$bus.on('playReportAudio', this.playBgm);
        this.$bus.on('stopReportAudio', this.stopBgm);
    },
    destroyed() {
        this.$bus.off('playReportAudio', this.playBgm);
        this.$bus.off('stopReportAudio', this.stopBgm);
    },
    methods: {
        initDom() {
            // this.indexAudioUrl = config.CONFIG_CDN_URL + 'audio/audio-index.mp3';
            // this.generateAudioUrl = config.CONFIG_CDN_URL + 'audio/audio-generate.mp3';
            // this.reportAudioUrl = config.CONFIG_CDN_URL + 'audio/audio-report.mp3';
            //先暂停所有的
            this.audioObj = document.getElementById('audio');
            this.audioUrl = config.CONFIG_CDN_URL + 'audio/audio-index.mp3';
            this.audioObj.load();
            // 绑定事件
            var me = this;
            this.audioObj.onplay = function() {
                document.removeEventListener('click', me.playBgm);
                document.removeEventListener('touchstart', me.playBgm);
                document.removeEventListener('touchmove', me.playBgm);
                document.removeEventListener('touchend', me.playBgm);
            }
            document.addEventListener('click', this.playBgm);
            document.addEventListener('touchstart', this.playBgm);
            document.addEventListener('touchmove', this.playBgm);
            document.addEventListener('touchend', this.playBgm);
        },
        playBgm() {
            this.stopBgm();
            var me = this;
            var curPath = this.$router.history.current.path;
            console.log('curPath------', curPath);
            setTimeout(() => {
                if(curPath.indexOf('generate') != -1) {
                    me.audioUrl = config.CONFIG_CDN_URL + 'audio/audio-generate.mp3';
                }else if(curPath.indexOf('report') != -1 || curPath.indexOf('home') != -1) {
                    me.audioUrl = config.CONFIG_CDN_URL + 'audio/audio-report.mp3';
                }else {
                    me.audioUrl = config.CONFIG_CDN_URL + 'audio/audio-index.mp3';
                }
                me.audioObj.load();
                me.audioObj.play();
                me.$store.state.audioPlay = true;
            }, 100);
        },
        stopBgm() {
            // if(this.indexAudio) { this.indexAudio.pause(); this.indexAudio.currentTime = 0; }
            // if(this.generateAudio) { this.generateAudio.pause(); this.generateAudio.currentTime = 0; }
            // if(this.reportAudio) { this.reportAudio.pause(); this.reportAudio.currentTime = 0; }
            if(this.audioObj) {
                this.audioObj.pause();
                this.audioObj.currentTime = 0;
            }
        }
    }
}
</script>